import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { SidebarSection } from './index'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenuSection',
  props: {
    icon: {},
    opened: { type: Boolean, default: false },
    condensed: { type: Boolean },
    label: {},
    menu: {},
    drop: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const active = ref<string>('')

function changed(name: string) {
  active.value = name
}

const __returned__ = { active, changed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})